/* eslint-disable */
// import {mask} from 'vue-the-mask'

export default {
  data() {
    return {
      setPage: false,
      show_list: false,
      itemsPerPage: 10
    }
  },
  // directives: { mask},
  methods: {
    set_por_paginas(itemsPerPage) {
      this.itemsPerPage = itemsPerPage
    },
  }
}
